module.exports = __webpack_public_path__ + "img/icons-clock.cf0b4557.svg";